var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamacasal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.44 -440.471)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.277,
    height: 6.182,
    transform: "translate(13.44 473.364)",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.277,
    height: 6.182,
    transform: "translate(59.397 473.364)",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.036,469.9H14.079a.64.64,0,0,1-.639-.639v-4.636a3.06,3.06,0,0,1,3.057-3.057H57.616a3.061,3.061,0,0,1,3.058,3.057v4.636A.639.639,0,0,1,60.036,469.9Zm-45.318-1.277H59.4v-4a1.782,1.782,0,0,0-1.781-1.78H16.5a1.782,1.782,0,0,0-1.78,1.78v4Z",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,462.85H18.11a.639.639,0,0,1-.638-.639V451.528a3.06,3.06,0,0,1,3.057-3.057H53.585a3.06,3.06,0,0,1,3.057,3.057v10.683A.639.639,0,0,1,56,462.85Zm-37.255-1.278H55.365V451.528a1.782,1.782,0,0,0-1.78-1.78H20.529a1.782,1.782,0,0,0-1.78,1.78v10.044Z",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.368,462.85H21.739a.639.639,0,0,1-.638-.639v-5.654a1.921,1.921,0,0,1,1.919-1.919H33.088a1.921,1.921,0,0,1,1.919,1.919v5.654A.641.641,0,0,1,34.368,462.85Zm-11.99-1.278H33.729v-5.016a.643.643,0,0,0-.642-.642H23.02a.643.643,0,0,0-.642.642Z",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.375,462.85H39.746a.638.638,0,0,1-.638-.639v-5.654a1.921,1.921,0,0,1,1.919-1.919H51.094a1.921,1.921,0,0,1,1.919,1.919v5.654A.639.639,0,0,1,52.375,462.85Zm-11.991-1.278H51.735v-5.016a.642.642,0,0,0-.642-.642H41.027a.643.643,0,0,0-.642.642v5.016Z",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.036,474H14.079a.639.639,0,0,1-.639-.638v-4.1a.64.64,0,0,1,.639-.639H60.036a.64.64,0,0,1,.639.639v4.1A.639.639,0,0,1,60.036,474Zm-45.318-1.276H59.4V469.9H14.718Z",
    fill: "#3a2e83"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamacasal);
export default __webpack_public_path__ + "static/media/cama casal.0d98c0209d35bcf8f803693f4cff1450.svg";
export { ForwardRef as ReactComponent };